<template>
  <div id="app" ref="app">
    <header-module v-if="$route.meta.showHeader && showview"></header-module>
    <router-view :key="$route.fullPath" v-if="showview"/>
    <footer-module></footer-module>
  </div>
</template>

<script>
import headerModule from '@/components/header/index'
import { getFid } from '@/api/userservice/index'
import footerModule from '@/components/footer/index'
export default {
  name: 'App',
  components: {
    headerModule,
    footerModule
  },
  data () {
    return {
      showview: false
    }
  },
  created () {
    /* 获取fid和code接口只请求一次！ 该接口获取首页访问量 */
    if (this.$cookie.get('culturalCloud_fid') === null) {
      this.setFid()
    }
    if (this.$cookie.get('museumCode') !== null) {
      this.showview = true
    }
  },
  mounted () {
  },
  methods: {
    /* 获取fid和code 所有接口都需要此接口运行完后请求 */
    setFid () {
      getFid({'domain': location.hostname}).then(res => {
        if (res.data.rel) {
          this.$cookie.set('culturalCloud_fid', res.data.data.f, { domain: location.hostname })
          this.$cookie.set('museumCode', res.data.data.c, { domain: location.hostname })
          if (this.$cookie.get('museumCode') !== null) {
            this.showview = true
          }
        }
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue